export const breakpoints = {
  xs: 480,
  sm: 600,
  md: 850,
  lg: 1280,
  xl: 1680,
  xxl: 1920,
};
